import { Flex, Text, Textarea, useToast } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { Button } from '../../../components/Button'
import { useEffect } from 'react'
import { useMutation } from 'react-query'
import { onUpdateObservacoes } from './functions/updateObservacoes'
import { ValidarLigacao } from './ValidarLigacao'

export function Observacoes({ dadosPedido }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm()

    const toast = useToast({
        position: 'top-right',
        duration: 3000,
        isClosable: true,
    })

    const { mutateAsync, isLoading: loading } = useMutation({
        mutationFn: onUpdateObservacoes,
        onSuccess: () => {
            toast({
                title: 'Observações atualizadas com sucesso',
                status: 'success',
            })
        },
        onError: (error) => {
            toast({
                title: 'Erro ao atualizar observações',
                description: error.message,
                status: 'error',
            })
        },
    })

    async function onSubmit(data) {
        await mutateAsync(data)
    }

    useEffect(() => {
        setValue('observacao_proposta', dadosPedido.detalhes_proposta)
    }, [dadosPedido, setValue])

    return (
        <>
            <Flex alignItems="center" justifyContent="center" bg="#ccc" fontSize="12px" fontWeight="bold" color="#555" py={3}>
                OBSERVAÇÕES DO PEDIDO
            </Flex>

            <Flex flexDir="column" gap={4} fontSize="12px">
                <Flex flexDir="column">
                    <Text color="#555" fontWeight="bold">
                        1. CONDIÇÕES DE PAGAMENTO:
                    </Text>{' '}
                    {dadosPedido.descricao_venda}
                </Flex>

                <Flex flexDir="column">
                    <Text color="#555" fontWeight="bold">
                        2. FRETE:
                    </Text>{' '}
                    {dadosPedido.texto_frete}
                </Flex>

                <Flex alignItems="center" gap={2} w="full">
                    <Text color="#555" fontWeight="bold" whiteSpace="nowrap" maxW="190px" w="full">
                        3 - DETALHES DA PROPOSTA:
                    </Text>{' '}
                    {dadosPedido.detalhes_propsota}
                    <Flex w="full" justifyContent="start" alignItems="center" gap={2} as="form" onSubmit={handleSubmit(onSubmit)}>
                        <input type="hidden" {...register('numero_nota')} value={dadosPedido.numero_nota} />
                        <Textarea
                            borderRadius="0"
                            bgColor={'#F5F5F5'}
                            _hover={{ borderColor: '#F5F5F5' }}
                            _focus={{ borderColor: '#F5F5F5' }}
                            borderColor={'#F5F5F5'}
                            my={2}
                            maxW="600px"
                            placeholder="Detalhes da proposta"
                            resize="none"
                            // disabled={dadosPedido.aprovacao_pedido}
                            rows={1}
                            {...register('observacao_proposta')}
                            isInvalid={!!errors.observacao_proposta}
                            errorBorderColor="red.300"
                        />
                        <Button type="submit" isLoading={loading} loadingText="Atualizando...">
                            Atualizar detalhes da proposta
                        </Button>
                    </Flex>
                </Flex>

                <ValidarLigacao nunota={dadosPedido.numero_nota} dadosPedido={dadosPedido} />
            </Flex>
        </>
    )
}
